export enum EmailPriority {
	Low = 10,
	Medium = 20,
	High = 0
}